import React, { useEffect, useState } from 'react';
import { getSorters } from '../api/Sorters';
import { ISorter } from '../util/DataModelInterface';
import { injectIntl } from 'react-intl';

interface ISorterListProps {
  intl: any;
}

const SorterList: React.FunctionComponent<ISorterListProps> = (props: ISorterListProps) => {
  const [sorters, setSorters] = useState([] as ISorter[]);

  useEffect(() => {
    getSorters().then((data: any) => {
      if (data) {
        setSorters(data as ISorter[]);
      }
    });
  }, []);

  const sorterList = () => {
    const sorterList : JSX.Element[] = [];
    sorterList.push(<option value="" key="sorter-0">{props.intl.formatMessage({id:'sorter-list.choose'})}</option>);
    if (sorters && Array.isArray(sorters)) {
      sorters.forEach((s) => {
        sorterList.push(<option value={s.id} key={`sorter-${s.id}`}>{s.name}</option>)
      });
    }
    return sorterList;
  }
  return <>{sorterList()}</>;
}

export default injectIntl(SorterList);
